export const roleHierarchy = [
  'visitor',
  'member',
  'coach',
  'admin'
] as TeamRole[]

export const EventVisibility = {
  Unlisted: -1,
  Public: 0,
  Member: 1,
  Coach: 2,
  Admin: 3
} as const

export const DEFAULT_BATCH_SIZE = 10
